
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './Navbar';

import SignUp from '../pages/SignUp';
import NotFound from '../pages/NotFound';

function AppRouter() {
    /**
       * [Router for Application with the Navbar included]
       * @return {[Router]} [Router for the whole application]
       */
    return (
        <Router>
            <Navbar />
            <Routes>
                <Route path="/register" exact element={<SignUp />}></Route>
                <Route path="/notfound" exact element= {<NotFound/>} ></Route>
                <Route path="" element= {<NotFound/>}></Route>
            </Routes>
        </Router>
    );
}

export default AppRouter;